import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Form } from 'components/atoms/form';
import {
  Caption01,
  ProductiveHeading07,
  ProductiveHeading06,
  Text02,
} from 'components/styles';

export const Title = styled.p<{ noMargin?: boolean }>`
  ${ProductiveHeading07};
  margin-bottom: var(--spacing-03);

  ${ifProp(
    { noMargin: true },
    css`
      margin: 0;
    `,
  )};
`;

export const Heading = styled.p<{ noMargin?: boolean }>`
  ${ProductiveHeading06};
  margin-bottom: var(--spacing-02);
`;

export const Help = styled.p<{ noMargin?: boolean }>`
  ${Caption01};

  ${ifProp(
    { noMargin: true },
    css`
      margin: 0;
    `,
  )};
`;

export const SubText = styled.p<{ noMargin?: boolean }>`
  ${Text02};

  ${ifProp(
    { noMargin: true },
    css`
      margin: 0;
    `,
  )};
`;

export const FormItem = styled(Form.Item)`
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
`;
